import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/components.css";
import "./styles/pages.css";
import App from "./App";

// StrictMode is deliberately off. It double-invokes every effect, which meant
// each page load fetched the 21MB expense ledger twice. This app is served by
// the CRA dev server in normal use, so that cost is paid for real rather than
// only in a throwaway dev session.
ReactDOM.createRoot(document.getElementById("root")).render(<App />);
